import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds';
import { Box } from '@cp/ds/src/components/box';
import { Grid } from '@cp/ds/src/components/grid';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';

interface BannerHowItWorksItemProps {
  body: React.ReactNode;
  backgroundImage?: React.ReactNode;
}

export interface BannerHowItWorksProps {
  items: BannerHowItWorksItemProps[];
}

const GridItem: React.FC<BannerHowItWorksItemProps> = ({ body, backgroundImage }) => {
  return (
    <Grid
      item
      md={4}
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        overflow: 'hidden',
        width: 'minContent',
        height: '478px',
        borderRadius: '20px',
      }}
      xs={12}
    >
      {backgroundImage}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          width: '100%',
          height: '100%',
          textAlign: 'center',
          pt: 2.5,
        }}
      >
        {body}
      </Box>
    </Grid>
  );
};

export const BannerHowItWorksBody: React.FC<BannerHowItWorksProps> = ({ items }) => {
  return (
    <Box sx={{ mt: { xs: 3.75, [MOBILE_BREAKPOINT_THRESHOLD]: 10 } }}>
      <Typography component="h2" sx={{ mb: { xs: 2.5, [MOBILE_BREAKPOINT_THRESHOLD]: 5 }, textAlign: 'center' }} variant="h2">
        Как это работает
      </Typography>
      <Grid
        container
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
          flexDirection: { xs: 'column', [MOBILE_BREAKPOINT_THRESHOLD]: 'row' },
          alignItems: 'center',
          gap: { xs: 1.5, [MOBILE_BREAKPOINT_THRESHOLD]: 2.5 },
        }}
      >
        {items.map((props, k) => (
          <GridItem {...props} key={k} />
        ))}
      </Grid>
    </Box>
  );
};
